// Firebase initialization for One Stop Greek website
// Initializes App, Auth, Firestore, Storage, and (optionally) Analytics

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported as analyticsIsSupported } from 'firebase/analytics';

// Use the provided config (shared with the mobile app)
const firebaseConfig = {
  apiKey: 'AIzaSyDseTYmtdX8Xq9FMNEifZiwUwGlO4hNKNg',
  authDomain: 'one-stop-greek.firebaseapp.com',
  projectId: 'one-stop-greek',
  storageBucket: 'one-stop-greek.firebasestorage.app',
  messagingSenderId: '292733390442',
  appId: '1:292733390442:web:2cdaf0b700dcb4d06b0413',
  measurementId: 'G-70FCDYJWP1'
};

// Initialize only once across hot reloads
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Core services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analytics: guard for environments where it's not supported (e.g., SSR)
let analytics = null;
if (typeof window !== 'undefined') {
  analyticsIsSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {
      // ignore analytics initialization errors
    });
}

export { app, analytics };


